import React from "react";

export default class RadioButton extends React.Component {
  state = { checked: false };

  handleChange = () => {
    this.props.handleChange({
      index: this.props.id,
      checked: !this.state.checked,
      name: this.props.name
    });
  };

  shouldComponentUpdate = nexProps => {
    return this.state.checked !== nexProps.checked;
  };

  componentWillReceiveProps = newProps => {
    this.setState({ checked: newProps.checked });
  };

  render() {
    const { id, name, className } = this.props;
    const inputId = id || this.props.label + this.props.type;
    return (
      <div className={className ? className : "col-4"}>
        <div className="radio">
          <input
            type="radio"
            id={inputId}
            checked={this.state.checked}
            onChange={this.handleChange}
          />
          <label htmlFor={inputId}>{this.props.label}</label>
        </div>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/blocks/filters/RadioButton.jsx